const getAcceptLanguage = () => {
  if (localStorage.getItem("i18nextLng").substr(0, 2) === "tr") {
    return "tr";
  } else {
    // return "en-US";
    return "tr";
  }
};

export default getAcceptLanguage;



// WEBPACK FOOTER //
// ./src/helpers/getLocale.js